export const hasSocialAssistance = [
  {
    id: 'Yes',
    title: 'Yes',
    description: "I'll use a social assistance program",
    data: true,
  },
  {
    id: 'No',
    title: 'No',
    description: "I'll cover the cost of my appointment",
    data: false,
  },
];

export const socialAssistanceExamples = {
  Illinois: ['Medicaid', 'Illinicare Health'],
  California: ['Medicaid', 'Denti-Cal'],
  'United States': ['Medicaid'],
  Canada: ['ODSP', 'Ontario Works', 'Healthy Smiles', 'IFHP'],
};
